import {ConfigProvider, Divider} from "antd";
import style from '../styles/expenses.salary.payrolls.module.css'
import SalaryStatementsTable from "./SalaryStatementsTable";
import ruRU from 'antd/locale/ru_RU';

const Header = () => {
    return (
        <div className={style.header}>
            <Divider style={{borderColor: '#7cb305'}}>Ведомости зарплат</Divider>
        </div>
    )
};


const ExpensesSalaryPayrolls = ({module_v}) => {
    return (
        <div>
            <Header/>
            <ConfigProvider locale={ruRU}>
                <div>
                    <SalaryStatementsTable module_v={module_v}/>
                </div>
            </ConfigProvider>
        </div>
    )
}

export default ExpensesSalaryPayrolls;